/**
 * Extracts attributes with the 'data-' prefix from a props object.
 *
 * @param props - props object containing data attributes
 * @returns a record of data attributes
 * @internal
 */
export function extractDataAttributes(
  props: Record<string, unknown>,
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(props).filter(([key]) => key.startsWith('data-')),
  );
}
